// src/redux/registerSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Register } from '../services/api'; 

// Async thunk for registration
export const registerUser = createAsyncThunk(
  'auth/register',
  async (userData, { rejectWithValue }) => {
    try {
      const response = await Register(userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const registerSlice = createSlice({
  name: 'register',
  initialState: {
    user: null,
    isRegistered: false,
    loading: false,
    error: null,
  },
  reducers: {
    // Optional: Reset registration state
    resetRegister: (state) => {
      state.isRegistered = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.isRegistered = false;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        // Check if the API response indicates success
        if (action.payload.status === true || action.payload.statues === true) {
          state.isRegistered = true;
          state.user = action.payload.user;
        } else {
          // API returned success: false, treat as error
          state.error = {
            message: action.payload.message || "Registration failed"
          };
          state.isRegistered = false;
        }
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isRegistered = false;
      });
  },
});

export const { resetRegister } = registerSlice.actions;
export default registerSlice.reducer;